module.exports = __webpack_public_path__ + "img/261.a503791e.jpg";